<template>
  <form @submit.prevent="beforeSave">
    <slot></slot>
  </form>
</template>

<script>
export default {
  inject: ['$validator'],
  props: {
    do: {
      type: Function,
      required: true
    },
    vErrors: {
      type: Object,
      required: false
    }
  },
  watch: {
    vErrors: {
      handler: function(value) {
        this.showErrors(value);
      },
      deep: true
    }
  },
  mounted() {
    const listener = () => {
      if ((event.ctrlKey || event.metaKey) && event.which === 83) {
        event.preventDefault();
        this.beforeSave();
      }
    };

    document.addEventListener('keydown', listener);
    this.$once('hook:beforeDestroy', () => {
      document.removeEventListener('keydown', listener);
    });
  },
  methods: {
    showErrors(errors) {
      for (let key in errors.details) {
        if (!errors.details.hasOwnProperty(key)) continue;

        const field = this.$validator.fields.find({ name: key });
        if (!field) continue;

        field.setFlags({
          invalid: true,
          valid: false,
          validated: true
        });

        this.$validator.errors.add({
          id: field.id,
          scope: field.scope,
          field: key,
          msg: errors.details[key][0]
        });
      }
    },
    async beforeSave() {
      const result = await this.$validator.validate();
      if (result) this.do();
    }
  }
};
</script>
